<div class="dialog-container">
    <h4 mat-dialog-title class="dialog-title">Create Schedule Process</h4>
    <div mat-dialog-content class="dialog-content text-muted">
        <form [formGroup]="processForm" class="col-12">
            <div class="row">
                <mat-form-field class="col-6" appearance="outline">
                    <mat-label>Schedule</mat-label>
                    <input type="text" matInput [formControl]="scheduleCtrl" [matAutocomplete]="autoSchedule" required>
                    <mat-autocomplete #autoSchedule="matAutocomplete"
                        (optionSelected)="onScheduleSelected($event.option.value)">
                        <mat-option *ngFor="let schedule of filteredSchedules | async" [value]="schedule.name">
                            {{ schedule.name }}
                        </mat-option>
                    </mat-autocomplete>
                    <button mat-icon-button matSuffix tabindex="-1">
                        <mat-icon>arrow_drop_down</mat-icon>
                    </button>
                </mat-form-field>
                <mat-form-field appearance="outline" class="col-6 custom-datetime-field">
                    <mat-label>Date Invoiced</mat-label>
                    <input matInput type="date" formControlName="selectedDate" required />
                    <!-- <mat-hint>MM/DD/YYYY</mat-hint> -->
                </mat-form-field>
            </div>
            <div class="row">
                <mat-form-field class="col-6" appearance="outline">
                    <mat-label>SSS Computation Period</mat-label>
                    <input type="text" matInput [formControl]="sssCtrl" [matAutocomplete]="autoSSS" required>
                    <mat-autocomplete #autoSSS="matAutocomplete" (optionSelected)="onSSSSelected($event.option.value)">
                        <!-- <mat-option [value]="''">-- None --</mat-option> -->
                        <mat-option *ngFor="let sss of filteredSSS | async" [value]="sss.name">
                            {{ sss.name }}
                        </mat-option>
                    </mat-autocomplete>
                    <button mat-icon-button matSuffix tabindex="-1">
                        <mat-icon>arrow_drop_down</mat-icon>
                    </button>
                </mat-form-field>
                <mat-form-field class="col-6" appearance="outline">
                    <mat-label>Philhealth Computation Period</mat-label>
                    <input type="text" matInput [formControl]="philhealthCtrl" [matAutocomplete]="autoPhilhealth"
                        required>
                    <mat-autocomplete #autoPhilhealth="matAutocomplete"
                        (optionSelected)="onPhilhealthSelected($event.option.value)">
                        <!-- <mat-option [value]="''">-- None --</mat-option> -->
                        <mat-option *ngFor="let phil of filteredPhilhealth | async" [value]="phil.name">
                            {{ phil.name }}
                        </mat-option>
                    </mat-autocomplete>
                    <button mat-icon-button matSuffix tabindex="-1">
                        <mat-icon>arrow_drop_down</mat-icon>
                    </button>
                </mat-form-field>
            </div>
            <div class="row">
                <mat-form-field class="col-6" appearance="outline">
                    <mat-label>PagIbig Computation Period</mat-label>
                    <input type="text" matInput [formControl]="pagIbigCtrl" [matAutocomplete]="autoPagIbig" required>
                    <mat-autocomplete #autoPagIbig="matAutocomplete"
                        (optionSelected)="onPagIbigSelected($event.option.value)">
                        <!-- <mat-option [value]="''">-- None --</mat-option> -->
                        <mat-option *ngFor="let pag of filteredPagIbig | async" [value]="pag.name">
                            {{ pag.name }}
                        </mat-option>
                    </mat-autocomplete>
                    <button mat-icon-button matSuffix tabindex="-1">
                        <mat-icon>arrow_drop_down</mat-icon>
                    </button>
                </mat-form-field>
            </div>
        </form>
    </div>
    <div mat-dialog-actions class="dialog-actions mt-0 text-right">
        <button mat-button class="cancel-button" (click)="onNoClick()">Cancel</button>
        <button *ngIf="!loading; else loadingTemplate" mat-button class="yes-button" cdkFocusInitial
            [disabled]="!processForm.valid" (click)="onSubmit()">Submit</button>
        <ng-template #loadingTemplate>
            <button mat-button class="yes-button" disabled>Submit&nbsp;
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            </button>
        </ng-template>
    </div>
</div>